/* eslint-disable no-param-reassign */
import {
  fetchCreativityLine, fetchCreativityReport,
  exportCreativityReport, getExportCreativityReportStatus, cancelExportCreativity,
  fuzzyMatchCreativity,fetchAudienceContant,fetchAudienceGraphicArea,fetchAudienceDetailContent,
  getExportAudiencesReportStatus, cancelExportAudiences, exportAudiencesReport,fetchAdPlanLine,
  fetchAdplanReport, exportAdplanReport, getExportAdPlanReportStatus, cancelExportPlan, 
  fetchAdFormLine, fetchAdFormReport, cancelExportAd, exportAdFormReport, getExportAdFormReportStatus,
  fetchHomeStatTrend, fetchAccountDataReport, getExportHomeDataStatus, cancelExportHomeData, exportAccountReport
} from '../services/api';

const fetchLine = {
  adCreativeId: fetchCreativityLine,
  adPlanId: fetchAdPlanLine,
  adFormId: fetchAdFormLine,
  adAccountData: fetchHomeStatTrend,
  global: fetchHomeStatTrend,
}

const fetchReport = {
  adCreativeId: fetchCreativityReport,
  adPlanId: fetchAdplanReport,
  adFormId: fetchAdFormReport,
  adAccountData: fetchAccountDataReport
}

const exportReport = {
  adCreativeId: {
    getStatus: getExportCreativityReportStatus,
    cancelExport: cancelExportCreativity,
    submitExport: exportCreativityReport,
  },
  AudiencesReport: {
    getStatus: getExportAudiencesReportStatus,
    cancelExport: cancelExportAudiences,
    submitExport: exportAudiencesReport,
  },
  adFormId: {
    getStatus: getExportAdFormReportStatus,
    cancelExport: cancelExportAd,
    submitExport: exportAdFormReport,
  },
  adPlanId: {
    getStatus: getExportAdPlanReportStatus,
    cancelExport: cancelExportPlan,
    submitExport: exportAdplanReport,
  },
  adAccountData: {
    getStatus: getExportHomeDataStatus, 
    cancelExport: cancelExportHomeData,
    submitExport: exportAccountReport,
  },
}

const depSetName = (arr, parent) => {
  if(arr && arr.length > 0) {
    arr.forEach((item) => {
      if (!parent) {
        item.name = item.title;
        item.idChain = item.id
      }
      else {
        item.idChain = `${parent.idChain}-${item.id}` 
        item.name = `${parent.name}-${item.title}`
      }
      if (item.children && item.children.length) {
        depSetName(item.children, item)
      }
    })
  }
}

export default {
  namespace: 'report',

  state: {
    creativity: {
      line: {
        dataSource: [],
        loading: false,
      },

      report: {
        dataSource: [],
        loading: false,
        total: 0,
      },
    },
    adCreativeList: [],
    
    AudiencesReport: {
      dataSource: [],
      loading: false,
    },

    AudienceDimensionTypeList: [],
    AudienceQueryIndexList: [],
  },

  effects: {

    *fuzzyMatchCreativity({ payload }, { call, put }) {
      const response = yield call(fuzzyMatchCreativity, payload);
      yield put({ type: 'setAdCreativeList', payload: response })
      return payload.type;
    },

    *fetchLine({ payload, scope }, { call, put }) {
      if (!(scope in fetchLine)) return
      else if(scope === 'adAccountData') {
        const { metrics } = payload
        const response = yield call(fetchLine[scope], payload);
        return (metrics || []).map(() => ({ list: (response || []).map(item => ({ ...item, dateTime: (item || {}).day, totalCost: (item || {}).cost })) }))
      }else {
        yield put({ type: 'setLoading', payload: { field: 'creativity', type: 'line', loading: true } })
        const response = yield call(fetchLine[scope], payload);
        yield put.resolve({ type: 'loadLine', payload: { field: 'creativity', data: response } })
        return response || []
      }
    },

    *fetchReport({ payload, field }, { call, put }) {
      yield put({ type: 'setLoading', payload: { field: 'creativity', type: 'report', loading: true } })
      const response = yield call(fetchReport[field], payload);
      if(response) yield put.resolve({ type: 'loadReport', payload: { field: 'creativity', data: response } })
      return response || {}
    },

    *exportReport({ payload, field, action }, { call }) {
      const response = yield call(exportReport[field][action], payload);
      return response
    },

    *cleanData({ field, dataType }, { put }) {
      const action = { line: 'loadLine', report: 'loadReport' }
      if (dataType in action) yield put.resolve({ type: action[dataType], payload: { field, data: null } })
    },

    *fetchAudienceContant(_,{ call, put }) {
      const response = yield call(fetchAudienceContant);
      yield put({ type: 'setAudienceContant', payload: response })
    },

    *fetchAudienceGraphicArea({ payload },{ call }) {
      const response = yield call(fetchAudienceGraphicArea, payload);
      return response
    },

    *fetchAudienceDetailContent({ payload }, { call, put }) {
      yield put({ type: 'setAudienceLoading' })
      const response = yield call(fetchAudienceDetailContent, payload);
      if(response) yield put.resolve({ type: 'loadAudienceReport', payload: { data: response } })
    },
  },

  reducers: {
    setLoading(state, { payload: { field, type, loading } }) {
      return {
        ...state,
        [field]: {
          ...state[field],
          [type]: {
            ...state[field][type],
            loading,
          },
          report: {
            dataSource: [],
            loading: false,
            total: 0,
          },
        },
      }
    },

    setAudienceLoading(state) {
      return {
        ...state,
        AudiencesReport: {
          dataSource: state.AudiencesReport.dataSource,
          loading: true,
        },
      }
    },
 
    loadLine(state, { payload: { field, data } }) {
      return {
        ...state,
        [field]: {
          ...state[field],
          line: {
            ...state[field].line,
            dataSource: data || [],
            loading: false,
          },
        },
      }
    },

    loadReport(state, { payload: { field, data } }) {
      const { list, total } = data || {}
      return {
        ...state,
        [field]: {
          ...state[field],
          report: {
            ...state[field].report,
            dataSource: list || [],
            total: total || 0,
            loading: false,
          },
        },
      }
    },

    loadAudienceReport(state, { payload: { data } }) {
      return {
        ...state,
        AudiencesReport: {
          dataSource: data,
          loading: false,
        },
      }
    },

    setAudienceContant(state, { payload }) {
      return {
        ...state,
        AudienceDimensionTypeList: (payload || []).dimensionTypeList,
        AudienceQueryIndexList: (payload || []).queryIndexList,
        dataLatestTime: (payload || []).dataLatestTime
      }
    },

    setAdCreativeList(state, { payload }) { 
      if(!payload) {
        return {
          ...state,
          adCreativeList: [],
        }
      }else {
        depSetName(payload.list)
        return {
          ...state,
          adCreativeList: payload.list,
        }
      }
    },
  },
};
